import { render, staticRenderFns } from "./TakeVitalAction.vue?vue&type=template&id=75144ee4&"
import script from "./TakeVitalAction.vue?vue&type=script&lang=js&"
export * from "./TakeVitalAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports